import { useCallback } from "react";
import useProductFavorite from "../../../hooks/useProductFavorite";

const useProductFavoriteAction = ({
  product,
  trackFavorite,
  navigate,
  location,
  showToast,
}) => {
  const { isFavorite, setIsFavorite, toggleFavorite } = useProductFavorite(
    product?._id,
  );

  const handleAddToFavorites = useCallback(async () => {
    if (!product?._id) return;

    const result = await toggleFavorite();
    if (result.success) {
      trackFavorite(product._id, result.isFavorite);
      return;
    }

    if (result.error?.response?.status === 401) {
      navigate("/login", {
        state: { from: location, action: "add to favorites" },
      });
      return;
    }

    showToast({
      message: "Failed to update favorites",
      type: "error",
    });
  }, [
    product,
    toggleFavorite,
    trackFavorite,
    navigate,
    location,
    showToast,
  ]);

  return { isFavorite, setIsFavorite, handleAddToFavorites };
};

export default useProductFavoriteAction;
